const SearchBlockInput = ({ onFocus, onBlur, onChange, value }) => {
  return (
    <>
      <input
        type="text"
        className="head_search_input"
        placeholder="Enter your keywords"
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
      />
      <button type="submit" className="head_search_btn">
        <img
          src={require('assets/images/search_icon.png').default}
          alt="search"
        />
      </button>
    </>
  );
};

export default SearchBlockInput;
